module.exports = __webpack_public_path__ + "assets/img/returnBtn-3758341a.png";